import '../Share4rewards/RewardSecSix.css'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import { useEffect, useState } from 'react';
import { Button, LinearProgress } from '@mui/material';
import { useParams } from 'react-router-dom';

function RewardSecSix(props) {


    const { uniqueID } = useParams();
    const [bannerLoading, setBannerLoading] = useState(false);
    useEffect(() => {
        if (uniqueID) {

            setBannerLoading(true);
        }
    }, [uniqueID])


    const findBackBtn = document.getElementById("goToTop");
    const goToTop = () => {
        const element = document.getElementById('sectionForm');
        if (element) {
            // 👇 Will scroll smoothly to the top of the next section
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    useEffect(() => {
        if (findBackBtn) {
            document.getElementById("goToTop").addEventListener('click', (event) => {
                goToTop()
            });
        }
    }, [findBackBtn])

    console.log("footerBanner props", props)


    return (
        <>
            <div className='share4rewards-container'>
                <div className='RewardSecSix_body'>
                    <div className='RewardSecSix_body_con'>
                        <div className='RewardSecSix_body_conmain'>
                            <div className='RewardSecSix_body_sub'>
                                <h2><span>Qualified Symptoms that lead to Medical</span> <span>Necessity for our Exam.</span></h2>
                                <div className='RewardSecSix_body_subGroup'>
                                    <ul>
                                        <li>Headaches</li>
                                        <li> Fatigue / Lack of energy</li>
                                        <li> Lack of concentration</li>
                                        <li>Numbness & Tingling in the hands and Feet</li>
                                        <li> Pins and needles sensation in feet</li>
                                        <li> Numbness (any part of the body)</li>
                                        <li> Obesity</li>
                                        <li> Blurred Vision</li>
                                        <li> Post Covid Complications</li>
                                        <li>Depression</li>
                                        <li> Weakness while exercising</li>
                                        <li>  Heartburn (especially frequent)</li>
                                        <li> Nausea (especially frequent)</li>
                                        <li> Lightheadedness / Dizziness</li>
                                        <li>Shortness of breath</li>
                                        <li>Increased Hunger</li>
                                        <li> Frequent Urination</li>
                                    </ul>
                                    <ul>
                                        <li>Difficulty digesting food</li>
                                        <li>  Fainting</li>
                                        <li>  Vomiting</li>
                                        <li>  Rapid, shallow breathing</li>
                                        <li> Irregular heartbeat, too fast/slow</li>
                                        <li>Extreme thirst</li>
                                        <li> Elevated blood sugar</li>
                                        <li>Chest pain that goes away with rest</li>
                                        <li> Urinary Problems</li>
                                        <li> Sexual difficulties</li>
                                        <li> Cold, Clammy, Pale Skin</li>
                                        <li>  Sweat abnormalities</li>
                                        <li> Burning sensations</li>
                                        <li> Swelling of ankles</li>
                                        <li> Pain in calves</li>
                                        <li>  Previous Heart Attack</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='RewardSecSix_body_conText'>
                            <h2><span>Learn more about our program today!</span></h2>
                             

                            <p className="paraTag"> Call our office and let's talk about how you can start helping your <span> customers and benefiting your community!</span> Even better, reward you and your employees every month just for sharing this life-changing exam!</p>
                        </div>
                    </div>
                    <div className='RewardSecSix_body_con'>
                        <div className='RewardSecSix_body_conmain'>
                            <div className='RewardSecSix_body_sub rewardBottom_bullets'>
                                <h2>
                                    <span>Disease States our Health Risk </span>
                                    <span>Exam Detects:</span>
                                </h2>
                                <ul>
                                    <li>Heart Attack </li>
                                    <li>Stroke </li>
                                    <li>Diabetes with complications </li>
                                    <li>Autonomic failure </li>
                                    <li> Multiple system dystrophy </li>
                                    <li> Peripheral vascular disease </li>
                                    <li> Nerve damage </li>
                                    <li> Cardiovascular associated diseases </li>
                                    <li> Heart rate variability issues </li>
                                    <li> Postpartum dysfunctions </li>
                                    <li>  Cardiac output to body surface area </li>
                                    <li> Abnormal LDL cholesterol levels </li>
                                    <li> Atherosclerosis </li>
                                    <li> Idiopathic neuropathy </li>
                                    <li> Amyloid neuropathy </li>
                                    <li>  Sjogren’s syndrome </li>
                                    <li>Insulin resistance </li>
                                    <li> Physical and mental stress, anxiety, and fatigue </li>
                                    <li> Angiotensin activity </li>
                                    <li> Hyperhidrosis and hypohidrosis </li>
                                    <li> Impaired glucose intolerance </li>
                                    <li>Obesity </li>
                                    <li> Asthma </li>
                                    <li> Psychological conditions </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {props && props.practiceData ?
                <div className='share4rewards-container'>
                    <div className='RewardSecSix_address_banner'>
                        <div className='RewardSecSix_address_banner_con'>
                            <div className='RewardSecSix_address_banner_Body'>
                                <div className='address_lefttext'>
                                    <h2><span>{props.practiceData.practice_name}</span></h2>
                                    <h3><span><img src='https://all-frontend-assets.s3.amazonaws.com/share4rewards/new_address_banner_icon2.webp' alt=''/></span><span>{props.practiceData.address}</span></h3>
                                </div>
                                <div className='address_righttext'>
                                    <div className='address_righttextNO'><Button><span className='ph_icon_wrpr'><img src='https://all-frontend-assets.s3.amazonaws.com/share4rewards/new_address_banner_icon1.webp' alt=''/></span> 
                                    {props.practiceData?.for_reward_partner_contact_no && props.practiceData.for_reward_partner_contact_no != '' ? 
                                    <a href={`tel:${props.practiceData.for_reward_partner_contact_no}`}>{props.practiceData.for_reward_partner_contact_no} </a>
                                :
                                <a href={`tel:${props.practiceData.phone}`}>{props.practiceData.phone} </a>
                                }
                                    </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : 
                <div className='share4rewards-container'>
                    <div className='RewardSecSix_address_banner'>
                        <div className='RewardSecSix_address_banner_con'>
                            <div className='RewardSecSix_address_banner_Body'>
                                <div className='address_lefttext'>
                                    <h2><span>True Health Family Medicine</span></h2>
                                    <h3><span><img src='https://all-frontend-assets.s3.amazonaws.com/share4rewards/new_address_banner_icon2.webp' alt=''/></span><span>2066 W. Apache Trail, suite 110 Apache Junction, AZ, 85120</span></h3>
                                </div>
                                <div className='address_righttext'>
                                    <div className='address_righttextNO'><Button><span className='ph_icon_wrpr'><img src='https://all-frontend-assets.s3.amazonaws.com/share4rewards/new_address_banner_icon1.webp' alt=''/></span> <a href={`tel:(623)257-5471`}>(623)257-5471 </a></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }

            {props && props.footerBanner ? <div className='share4rewards-container' dangerouslySetInnerHTML={{ __html: props.footerBanner }}></div> : ""}
        </>
    )
}

export default RewardSecSix;


